import { useDispatch, useSelector } from "react-redux";
import { CURRENCY } from "../constants";
import { selectUser, updateUser } from "../store/auth-slice";
import { useState } from "react";
import { useMpesaWithdrawMutation } from "../store/apis";
import { handleApiError } from "../errors";
import { toastService } from "../screens/notificationPage/ToastContainer";
export const WithdrawModal = ({ onClose }) => {
  const [withdraw, { isLoading }] = useMpesaWithdrawMutation();
  const [withdrawAmount, setWithdrawAmount] = useState(0);
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const handleWithdraw = async () => {
    if (isNaN(withdrawAmount) || withdrawAmount <= 0) {
      alert("Please enter a valid deposit amount");
      return;
    }
    if (withdrawAmount > user.balance) {
      toastService.error("Error! Insufficient funds!!");

      return;
    }
    try {
      // const response = await withdraw({
      //   phoneNumber: user.username,
      //   amount: withdrawAmount,
      //   remarks: "Withdrawal",
      //   commandID: "BusinessPayment",
      // }).unwrap();
      // dispatch(updateUser(response.user));
      // setWithdrawAmount(0);
      // onClose();
      console.log("Mpesa payment disable for now!!");
    } catch (error) {
      handleApiError(error, {
        // setErrors,
        showToast: true,
        toastPosition: "top-center",
      });
      console.log(error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-[#1E3A5F] rounded-2xl p-6 w-96">
        <h2 className="text-2xl font-bold mb-4 dark:text-white">
          Withdraw Funds
        </h2>
        <div className="mb-4">
          <label className="block text-gray-700 dark:text-gray-300 mb-2">
            Withdrawal Amount
          </label>
          <div className="flex items-center">
            <span className="mr-2 text-gray-500 dark:text-gray-400">
              {CURRENCY}
            </span>
            <input
              type="number"
              value={withdrawAmount}
              onChange={(e) => setWithdrawAmount(Number(e.target.value))}
              className="w-full p-2 border rounded dark:bg-[#2A4365] dark:border-gray-600 dark:text-white"
              placeholder="Enter amount"
            />
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
            Available Balance:{CURRENCY}
            {user && Number(user.balance).toFixed(2)}
          </p>
        </div>
        <div className="flex justify-between">
          <button
            onClick={onClose}
            className="bg-darkblue text-yellow border-[2px] border-solid border-darkblue dark:border-white hover:bg-transparent hover:bg-transparent dark:hover:bg-transparent dark:hover:text-white hover:text-darkblue transition-all duration-[0.3s] dark:bg-white rounded-[7px] dark:text-darkblue px-4 py-2 rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleWithdraw}
            className="bg-[#EBBC1350] dark:bg-yellow dark:hover:bg-[#EBBC1350] rounded-md p-3 sm:p-[19px] hover:bg-[#EBBC13] text-[#0C2240] text-sm s15:text-[17px] font-medium px-4 py-2 rounded"
          >
            {isLoading ? "Processing" : "Withdraw"}
          </button>
        </div>
      </div>
    </div>
  );
};
